import { Container } from "react-bootstrap";

import "./ts-cs.scss";
// import { TermsConditionsData } from "./ts-cs-data";
import { TermsConditionsDataVoice } from "./tcs-voice-data";

export const TermsAndConditionsVoices = () => {
  return (
    <section>
      <Container className="px-3">
        <div className="ts-cs-content mt-5">
          <p className="fs-2 fw-bold  privacy-title text-center">PAMO VOICE FEATURE: TERMS OF USE
          </p>
          <p className="ts-cs-description fs-6 ">
          THESE TERMS OF USE APPLY TO GOVERN THE SPECIFIC CONDITIONS OF THE VOICE MESSAGE FEATURE WITHIN THE PAMO APP (“THE APP”). 
THESE TERMS SUPPLEMENT THE GENERAL TERMS AND CONDITIONS OF THE APP.
          </p>
        </div>

        <div className="mb-5">
          {TermsConditionsDataVoice.map((data, key) => (
            <ul key={key}>
              <div className="fs-5 fw-bold mt-5 ts-cs-items">
                {data.listName}
              </div>
              {data.list.map((data, key) => (
                <li className="my-2 ts-cs-items">{data.item}</li>
              ))}
            </ul>
          ))}
        </div>
      </Container>
    </section>
  );
};
